import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import iconFacebook from '@images/icons/facebook.svg';
import iconInstagram from '@images/icons/instagram.svg';
import iconTwitter from '@images/icons/twitter.svg';
import iconYoutube from '@images/icons/youtube.svg';
import iconHamburger from '@images/icons/hamburger.svg';
import iconArrow from '@images/icons/arrow.svg';
import iconCc from '@images/icons/cc.svg';
import iconCcMaster from '@images/icons/cc-master.svg';
import iconCcVisa from '@images/icons/cc-visa.svg';
import iconChevronDown from '@images/icons/chevron-down.svg';
import iconWhiteChevronDown from '@images/icons/chevron-down-white.svg';
import iconClose from '@images/icons/close.svg';
import iconCvc from '@images/icons/cvc.svg';
import iconDownload from '@images/icons/download.svg';
import iconExpand from '@images/icons/expand.svg';
import iconInfo from '@images/icons/info.svg';
import iconLinkedIn from '@images/icons/linked-in.svg';
import iconPause from '@images/icons/pause.svg';
import iconPlay from '@images/icons/play.svg';
import iconPlus from '@images/icons/plus.svg';
import iconMinus from '@images/icons/minus.svg';
import iconSearch from '@images/icons/search.svg';
import iconSound from '@images/icons/sound.svg';
import iconSoundMute from '@images/icons/sound-mute.svg';
import iconXMenu from '@images/icons/x-menu.svg';
import iconArrowDown from '@images/icons/arrow-down.svg';
import iconArrowLeft from '@images/icons/arrow-left.svg';
import iconArrowRight from '@images/icons/arrow-right.svg';
import styles from './Icon.module.scss';

const ICONS = {
  facebook: iconFacebook,
  instagram: iconInstagram,
  twitter: iconTwitter,
  youtube: iconYoutube,
  'linked-in': iconLinkedIn,
  cc: iconCc,
  'cc-master': iconCcMaster,
  'cc-visa': iconCcVisa,
  pause: iconPause,
  play: iconPlay,
  sound: iconSound,
  'sound-mute': iconSoundMute,
  hamburger: iconHamburger,
  arrow: iconArrow,
  'chevron-down': iconChevronDown,
  'white-chevron-down': iconWhiteChevronDown,
  close: iconClose,
  cvc: iconCvc,
  download: iconDownload,
  expand: iconExpand,
  info: iconInfo,
  plus: iconPlus,
  minus: iconMinus,
  search: iconSearch,
  'x-menu': iconXMenu,
  'arrow-down': iconArrowDown,
  'arrow-left': iconArrowLeft,
  'arrow-right': iconArrowRight,
};

export const Icon = ({ type }) => {
  const additionalClass = styles[type] || '';
  return (
    <i className={cn(styles.wrap, additionalClass)}>
      <img src={ICONS[type]} alt={type} />
    </i>
  );
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
};
